import { useEffect } from "react";
import { track } from "../lib/plausible";

export function Researchers() {
  useEffect(() => {
    track("persona_landing_view", { persona: "researcher" });
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-6 py-12 space-y-10">
      <header className="space-y-3">
        <h1 className="text-3xl md:text-4xl font-semibold">
          Chart data extraction for meta-analyses and systematic reviews
        </h1>
        <p className="text-ink/70 text-lg">
          Drag a published figure. Get series-level CSV. Verify visually against the
          source before including in your dataset.
        </p>
      </header>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">For researchers and grad students</h2>
        <ul className="space-y-2 text-ink/80">
          <li>· Published paper figure → series-level CSV for meta-analysis or systematic review</li>
          <li>· Error-bar charts handled (precision varies — see harness)</li>
          <li>· Log-scale, dual-axis, scatter, line, bar — all in the test fixture set</li>
          <li>· Public accuracy harness at <a href="/accuracy" className="underline">/accuracy</a> — cite the methodology in your write-up</li>
          <li>· Verification overlay re-plots extracted points on source chart — defensible at peer review</li>
          <li>· Faster than WebPlotDigitizer (~6s vs ~20–40 min per chart × N papers)</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">Pricing</h2>
        <p className="text-ink/80">
          <strong>$7/mo</strong> unlimited charts, 50 MB upload limit, cancel anytime.
          14-day refund. Below the WebPlotDigitizer Pro one-time fee, with verification UX.
        </p>
      </section>

      <section className="space-y-3">
        <a
          href="/"
          onClick={() => track("persona_landing_cta", { persona: "researcher" })}
          className="btn-primary inline-block"
        >
          Try it free — 5 charts/day
        </a>
        <p className="text-sm text-ink/60">
          Or see the public <a href="/accuracy" className="underline">accuracy harness</a> first.
        </p>
      </section>
    </div>
  );
}
